<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-default">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">即売会参加情報
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">直近の参加予定即売会について</h2>
            <p v-if="recentEvents.length" class="lead">直近の参加予定の即売会は以下の通りです。</p>
            <p v-else class="lead">直近で参加予定の即売会はありません。</p>
          </div>
        </div>
        <div v-for="(item,index) in recentEvents" :key="item.id">
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <h3>{{ item.attributes.Name }}</h3>
                <h5>開催日：{{ item.attributes.StartDate }}</h5>
                <h5>場所：{{ item.attributes.Prefecture }}・{{ item.attributes.Place }}</h5>
                <h5>状態：{{ item.attributes.EventStatus }}</h5>
                <div v-if="item.attributes.EventStatus == '参加' || item.attributes.EventStatus == '終了' || item.attributes.EventStatus == 'Placed' || item.attributes.EventStatus == 'Finished'">
                  <h5>配置：{{ item.attributes.Position }}</h5>
                </div>
                <p v-html="item.attributes.Description"></p>
                <div class="btn-wrapper">
                  <router-link :to="item.attributes.EventDetailUrl">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="ni ni-calendar-grid-58">
                      詳細情報
                    </base-button>
                  </router-link>
                  &nbsp;
                  <span v-if="item.attributes.Url">
                    <a :href="item.attributes.Url" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="primary"
                                   icon="ni ni-building">
                        イベントHP
                      </base-button>
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src=item.attributes.CircleCut.data.attributes.url class="img-fluid">
            </div>
          </div>
          <hr v-show="index !== recentEvents.length - 1">
        </div>
      </div>
    </section>
    <section class="section section-lg bg-secondary">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">過去に参加した即売会</h2>
          </div>
        </div>
        <div v-for="(item,index) in previousEvents" :key="item.id">
          <div class="row row-grid align-items-center pb-100">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <h3>{{ item.attributes.Name }}</h3>
                <h5>開催日：{{ item.attributes.StartDate }}</h5>
                <h5>場所：{{ item.attributes.Prefecture }}・{{ item.attributes.Place }}</h5>
                <h5>状態：{{ item.attributes.EventStatus }}</h5>
                <div v-if="item.attributes.EventStatus == '参加' || item.attributes.EventStatus == '終了' || item.attributes.EventStatus == 'Placed' || item.attributes.EventStatus == 'Finished'">
                  <h5>配置：{{ item.attributes.Position }}</h5>
                </div>
                <p v-html="item.attributes.Description"></p>
                <div class="btn-wrapper">
                  <router-link :to="item.attributes.EventDetailUrl">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="ni ni-calendar-grid-58">
                      詳細情報
                    </base-button>
                  </router-link>
                  &nbsp;
                  <span v-if="item.attributes.Url">
                    <a :href="item.attributes.Url" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="primary"
                                   icon="ni ni-building">
                        イベントHP
                      </base-button>
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src=item.attributes.CircleCut.data.attributes.url class="img-fluid">
            </div>
          </div>
          <hr v-show="index !== previousEvents.length - 1">
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import 'moment/locale/ja'
import moment from "moment";

export default {
  name: "events",
  components: {
    moment
  },
  data() {
    return{
      recentEvents: [],
      previousEvents: [],
    };
  },
  head: {
    meta: function () {
      return [
        { property: 'og:title', content: '雛菊書房 - 即売会参加情報' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: '小説二次創作中心同人小説サークル「雛菊書房」の即売会参加情報' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary' },
      ]
    }
  },
  created() {
    moment.locale('ja')
    this.getRecentEvents()
    this.getPreviousEvents()
  },
  methods: {
    getRecentEvents() {
      let today = moment().format('YYYY-MM-DD')
      this.axios.get('/strapi/api/event-informations?populate=%2A&sort[0]=StartDate%3Aasc&pagination[limit]=3&filters[StartDate][$gte]=' + today)
          .then(response => {
            this.recentEvents = response.data.data
            this.recentEvents.forEach(function (value, index, array){
              array[index]['attributes']['StartDate'] = moment(value['attributes']['StartDate']).format('YYYY/MM/DD(ddd)')
              array[index]['attributes']['EndDate'] = moment(value['attributes']['EndDate']).format('YYYY/MM/DD(ddd)')
              if (value['attributes']['EventStatus'] == "Announced"){
                array[index]['attributes']['EventStatus'] = "開催告知あり"
              } else if (value['attributes']['EventStatus'] == "Planning"){
                array[index]['attributes']['EventStatus'] = "参加予定"
              } else if (value['attributes']['EventStatus'] == "Submitted"){
                array[index]['attributes']['EventStatus'] = "申込済み"
              } else if (value['attributes']['EventStatus'] == "Listed"){
                array[index]['attributes']['EventStatus'] = "配置発表待ち（当選済み）"
              } else if (value['attributes']['EventStatus'] == "Placed"){
                array[index]['attributes']['EventStatus'] = "参加"
              } else if (value['attributes']['EventStatus'] == "Finished"){
                array[index]['attributes']['EventStatus'] = "終了"
              } else if (value['attributes']['EventStatus'] == "Suspended"){
                array[index]['attributes']['EventStatus'] = "中止/延期"
              } else if (value['attributes']['EventStatus'] == "Postponed"){
                array[index]['attributes']['EventStatus'] = "延期"
              } else if (value['attributes']['EventStatus'] == "Cancelled"){
                array[index]['attributes']['EventStatus'] = "中止"
              } else if (value['attributes']['EventStatus'] == "Declined"){
                array[index]['attributes']['EventStatus'] = "欠席/辞退"
              }
              if (array[index]['attributes']['Description'] !== null){
                array[index]['attributes']['Description'] = value['attributes']['Description'].replace(/\r?\n/g, '<br >');
              }
              array[index]['attributes']['EventDetailUrl'] = "eventDetail/" + value['id']
              if(array[index]['attributes']['CircleCut']['data']){
                array[index]['attributes']['CircleCut']['data']['attributes']['url'] = '/strapi' + value['attributes']['CircleCut']['data']['attributes']['url']
              }
            })
          }).catch(error =>{
        console.log(error)
      })
    },
    getPreviousEvents() {
      let today = moment().format('YYYY-MM-DD')
      this.axios.get('/strapi/api/event-informations?populate=%2A&pagination[pageSize]=50&sort[0]=StartDate%3Adesc&filters[StartDate][$lt]=' + today)
          .then(response => {
            this.previousEvents = response.data.data
            this.previousEvents.forEach(function (value, index, array){
              array[index]['attributes']['StartDate'] = moment(value['attributes']['StartDate']).format('YYYY/MM/DD(ddd)')
              array[index]['attributes']['EndDate'] = moment(value['attributes']['EndDate']).format('YYYY/MM/DD(ddd)')
              if (value['attributes']['EventStatus'] == "Announced"){
                array[index]['attributes']['EventStatus'] = "開催告知あり"
              } else if (value['attributes']['EventStatus'] == "Planning"){
                array[index]['attributes']['EventStatus'] = "参加予定"
              } else if (value['attributes']['EventStatus'] == "Submitted"){
                array[index]['attributes']['EventStatus'] = "申込済み"
              } else if (value['attributes']['EventStatus'] == "Listed"){
                array[index]['attributes']['EventStatus'] = "配置発表待ち（当選済み）"
              } else if (value['attributes']['EventStatus'] == "Placed"){
                array[index]['attributes']['EventStatus'] = "参加"
              } else if (value['attributes']['EventStatus'] == "Finished"){
                array[index]['attributes']['EventStatus'] = "終了"
              } else if (value['attributes']['EventStatus'] == "Suspended"){
                array[index]['attributes']['EventStatus'] = "中止/延期"
              } else if (value['attributes']['EventStatus'] == "Postponed"){
                array[index]['attributes']['EventStatus'] = "延期"
              } else if (value['attributes']['EventStatus'] == "Cancelled"){
                array[index]['attributes']['EventStatus'] = "中止"
              } else if (value['attributes']['EventStatus'] == "Declined"){
                array[index]['attributes']['EventStatus'] = "欠席/辞退"
              }
              if (array[index]['attributes']['Description'] !== null){
                array[index]['attributes']['Description'] = value['attributes']['Description'].replace(/\r?\n/g, '<br >');
              }
              array[index]['attributes']['EventDetailUrl'] = "eventDetail/" + value['id']
              if(array[index]['attributes']['CircleCut']['data']){
                array[index]['attributes']['CircleCut']['data']['attributes']['url'] = '/strapi' + value['attributes']['CircleCut']['data']['attributes']['url']
              }
            })
          }).catch(error =>{
        console.log(error)
      })
    }
  }
};
</script>
<style>
</style>
